import React from 'react';
import styled from 'styled-components';
import { Caption } from '../styles/Typography';

const TextArea = ({ label, value, placeholder, onChange, error }) => (
  <Container>
    <Label>
      {error ? (
        <Caption style={{ color: 'red' }}>
          {label} - {error}
        </Caption>
      ) : (
        <Caption>{label}</Caption>
      )}
    </Label>
    <StyledTextArea
      onChange={onChange}
      placeholder={placeholder}
      value={value}
    />
  </Container>
);

export default TextArea;

const Container = styled.div`
  margin: 0 0 2rem;
  padding: 0;

  &:last-child {
    margin: 0;
  }
`;

const Label = styled.label`
  display: block;
  color: inherit;
  margin: 0 0 0.5rem;
  text-align: left;
`;

const StyledTextArea = styled.textarea`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  font-family: inherit;
  display: block;
  background-color: white;
  color: #6e514c;
  padding: 1.25rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid white;
  outline: none;
  margin: 0;
  width: 100%;
  resize: none;
  height: 8rem;

  font-size: 0.8125rem;
  line-height: 1rem;

  @media (min-width: 500px) {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5;
  }

  &::placeholder {
    color: #6e514c;
    opacity: 0.4;
  }

  &:disabled {
    opacity: 1;
    color: hsl(0, 0%, 80%);
    background-color: hsl(0, 0%, 97%);
    border: 1px solid hsl(0, 0%, 97%);
    cursor: not-allowed;
  }
  &:focus {
    border: 1px solid #e2b3aa;
  }
`;
